/** @format */
import { ChangeDetectionStrategy, Component, Inject, Input, Optional, ViewEncapsulation } from '@angular/core';
import { CourseUnit } from 'common-typescript/types';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';

@Component({
    selector: 'sis-course-unit-attainment-box',
    templateUrl: './course-unit-attainment-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CourseUnitAttainmentBoxComponent {
    @Input({ required: true }) courseUnit: CourseUnit;

    constructor(@Optional() @Inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN) private readonly planActionsService: PlanActionsService) {}

    openAttainmentDetailsModal() {
        this.planActionsService?.openAttainmentDetailsModal(this.courseUnit);
    }
}
